// extracted by mini-css-extract-plugin
export default {"header":"Header_header__g+xcV","hello":"Header_hello__IsFsi","info":"Header_info__EfXMi","info_img":"Header_info_img__khZ+8","bell_img":"Header_bell_img__rTbYz"};